import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { DataService } from '../../services/data.service';
import { MatSnackBar } from '@angular/material/snack-bar';

@Component({
  selector: 'app-mfg-footer',
  templateUrl: './mfg-footer.component.html',
  styleUrls: ['./mfg-footer.component.scss']
})
export class MfgFooterComponent implements OnInit {
selectedIcon:string="home";
homeIcon="../../../../assets/images/home.svg";
homeIconFill="../../../../assets/images/home_select.svg";
shopIcon="../../../../assets/images/shop.svg";
shopIconFill="../../../../assets/images/shop_select.svg";
cartIcon="../../../../assets/images/cart.svg";
cartIconFill="../../../../assets/images/cart_select.svg";
profileIcon ="../../../../assets/images/profile.svg";
profileIconFill ="../../../../assets/images/Profile_select.svg";
totalCartItems;
cartCount:number=0;
  constructor(private router:Router,private dataService: DataService,private snackBar: MatSnackBar) { }

  ngOnInit(): void {
    this.totalCartItems = this.dataService.getCartItemCount();
    this.dataService.cartCount$.subscribe((cartCount) =>{
this.cartCount = cartCount;
    });
    this.dataService.activeFooterObjs$.subscribe((value)=>{
      if(value!=""){
        console.log("icon fill",value)
        this.selectedIcon=value;
      } 
    });
  }
  changeIconColor(path:string, icon: string): void {
  
    this.selectedIcon = icon;
     if(localStorage.getItem('user') && localStorage.getItem('loginType')){
      //checks path if cart count = 0 shows message toast
      if(path=='/shop/mfg-cart' && this.cartCount == 0){
       
        this.snackBar.open('Cart is empty. Add Items to cart', 'Close', {
          duration: 5000,// Set the duration in milliseconds
         
        });
        return
      }
     
      console.log(icon)
      this.dataService.setFooterActie(icon);
      this.router.navigateByUrl(`${path}`);
    
     }
     else{
      
      this.selectedIcon = icon;
       this.dataService.setFooterActie(icon);
       this.router.navigate(['landscreen']);
     }
  }
 
}